<template>
  <div class="category-field-item d-inline-block align-middle">
    <h3 class="cursor-pointer" @click="slideClassActive = !slideClassActive">{{ field_category_values.field_label }} ({{ field_category_values.type }} field)</h3>
    <div class="field-block-wrapper-class" :class="slideClassActive ? 'slide-down' : 'slide-up'">
      <div v-for="(fieldValue, machineName) in field_category_values" class="">

        <div class="text-block-wrapper" >
          <div class="form-group-beside row" v-if="machineName != 'type'">
            <label class="col-6">{{ machineName }}</label>
            <div class="col-6" v-if="machineName == 'description'">
              <jodit-vue v-model="field_category_values[machineName]" :buttons="buttons" class="form-control" :name="'layout['+index+']'+'[' + machineName + ']'"></jodit-vue>
            </div>
            <input v-if="machineName !== 'required' && machineName !== 'description'  && machineName !== 'machine_name'" type="text" :name="'layout['+index+']'+'[' + machineName + ']'" v-model="field_category_values[machineName]" class="col-6 form-control">
            <div class="col-6 pl-0" v-if="machineName === 'machine_name' && (field_category_values.type === 'text' || field_category_values.type === 'textarea' || field_category_values.type === 'file_upload' || field_category_values.type === 'image_upload')">
              <select v-model="field_category_values[machineName]">
                <option v-if="field_category_values.type === 'text'" v-for="field in all_text_fields" :disabled="used_text_fields.includes(field)" :value="field" v-model="field_category_values['machine_name']">{{ field }}</option>
                <option v-if="field_category_values.type === 'textarea'" v-for="field in all_textarea_fields" :disabled="used_textarea_fields.includes(field)" :value="field" v-model="field_category_values['machine_name']">{{ field }}</option>
                <option v-if="field_category_values.type === 'file_upload'" v-for="field in all_fileupload_fields" :disabled="used_fileupload_fields.includes(field)" :value="field" v-model="field_category_values['machine_name']">{{ field }}</option>
                <option v-if="field_category_values.type === 'image_upload'" v-for="field in all_imageupload_fields" :disabled="used_imageupload_fields.includes(field)" :value="field" v-model="field_category_values['machine_name']">{{ field }}</option>
              </select>
            </div>

            <div class="col-10 col-md-6 input-wrapper" v-if="machineName === 'required'">
              <div class="toggle-js">
                <span class="yes-toggle" :class="thirdPartyUploaderActiveClass" @click="thirdPartyUploaderActive(1, machineName)"><checkmark class="svg-18 svg-black"></checkmark> Yes</span>
                <span class="no-toggle"  :class="thirdPartyUploaderActiveClass" @click="thirdPartyUploaderActive(0, machineName)"><closeicon class="svg-18 svg-black"></closeicon> No</span>
              </div>
              <input type="hidden" :name="'layout['+index+']'+'[required]'" v-model="field_category_values['required']" id="third_party_uploader" class="form-control third_party_uploader">
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import checkmark from '../components/icons/checkmark.vue';
import closeicon from '../components/icons/close.vue';

export default {
  components: {checkmark, closeicon},
  props: ['field_layout_values', 'index', 'all_text_fields', 'used_text_fields', 'all_textarea_fields', 'used_textarea_fields', 'all_fileupload_fields', 'used_fileupload_fields', 'all_imageupload_fields', 'used_imageupload_fields'],
  data() {
    return {
      buttons: ['bold', 'underline', 'italic', 'eraser', 'ul', 'ol', 'fontsize', 'link'],
      thirdPartyUploaderActiveClass: '',
      slideClassActive: false,
      field_category_values: this.field_layout_values
    }
  },
  mounted() {
    let app = this;
    if (app.field_category_values['required'] === 1 || app.field_category_values['required'] === 'true') {
      app.thirdPartyUploaderActiveClass = 'active-yes';
    } else if(app.field_category_values['required'] === 0 || app.field_category_values['required'] === 'false') {
      app.thirdPartyUploaderActiveClass = 'active-no';
    }
  },
  methods: {
    thirdPartyUploaderActive: function (value) {
      let app = this;
      app.field_category_values['required'] = value;
      if(app.field_category_values['required'] == 1) {
        app.thirdPartyUploaderActiveClass = 'active-yes';
      } else if (app.field_category_values['required'] == 0) {
        app.thirdPartyUploaderActiveClass = 'active-no';
      }
    }
  }
}
</script>